import { API_TYPE_CALL_API, API_TYPE_DOWNLOAD_FILE, METHOD, X_UNIT_GROUP_ID, SERVER } from 'shared/constants';
import api from './api';

const ACCESS_MANAGEMENT_API_GETS = `${SERVER}/form-data/v1/visitor`;
const ACCESS_MANAGEMENT_API_EXPORT = `${SERVER}/form-data/v1/visitor/export`;
const ACCESS_MANAGEMENT_API_ADD = `${SERVER}/form-data/v1/visitor`;
const ACCESS_MANAGEMENT_API_REMOVE = (id) => `${SERVER}/form-data/v1/visitor/${id}`;
const ACCESS_MANAGEMENT_API_APPROVE = (id) => `${SERVER}/form-data/v1/visitor/${id}/approve`;
const ACCESS_MANAGEMENT_API_CANCEL = (id) => `${SERVER}/form-data/v1/visitor/${id}/cancel`;
const ACCESS_MANAGEMENT_API_IN_PROGRESS = (id) => `${SERVER}/form-data/v1/visitor/${id}/in-progress`;
const ACCESS_MANAGEMENT_API_COMPLETE = (id) => `${SERVER}/form-data/v1/visitor/${id}/complete`;
const ACCESS_MANAGEMENT_COUNT_BADGES = `${SERVER}/form-data/v1/visitor/count-badges`;

export const getAccessManagementsService = async ({ filter, limit, page, idBuilding }) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_GETS,
      method: METHOD.GET,
      options: {
        params: {
          ...filter,
          page,
          limit,
        },
        headers,
      },
    },
  });
  return response;
};

export const exportAccessManagementsService = async (filterObj, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_DOWNLOAD_FILE,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_EXPORT,
      method: METHOD.GET,
      options: { params: { ...filterObj }, headers },
    },
  });
  return response;
};

export const addAccessManagementService = async (body, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_ADD,
      method: METHOD.POST,
      body,
      options: {
        headers,
      },
    },
  });
  return response;
};

export const removeAccessManagementService = async (id, body, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_REMOVE(id),
      method: METHOD.DELETE,
      body,
      options: {
        headers,
      },
    },
  });
  return response;
};

export const approveAccessManagementService = async (id, body, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_APPROVE(id),
      method: METHOD.PUT,
      body,
      options: {
        headers,
      },
    },
  });
  return response;
};

export const rejectAccessManagementService = async (id, body, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_CANCEL(id),
      method: METHOD.PUT,
      body,
      options: {
        headers,
      },
    },
  });
  return response;
};

export const inProgressAccessManagementService = async (id, body, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_IN_PROGRESS(id),
      method: METHOD.PUT,
      body,
      options: {
        headers,
      },
    },
  });
  return response;
};

export const completeAccessManagementService = async (id, body, idBuilding) => {
  const headers = { [X_UNIT_GROUP_ID]: idBuilding };
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_API_COMPLETE(id),
      method: METHOD.PUT,
      body,
      options: {
        headers,
      },
    },
  });
  return response;
};

export const countBadgesAccessManagementService = async (idBuilding) => {
  const response = await api({
    type: API_TYPE_CALL_API,
    payload: {
      apiUrl: ACCESS_MANAGEMENT_COUNT_BADGES,
      method: METHOD.GET,
      options: {
        headers: {
          [X_UNIT_GROUP_ID]: idBuilding,
        },
      },
    },
  });
  return response;
};
